const sectionReviewGrid02Css = `
[data-type='section-review-grid-02'] [data-attribute='review-grid-container'] {
  padding: 40px 0;
}

[data-type='section-review-grid-02'] .wrap-review-grid {
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

[data-type='section-review-grid-02'] .wrap-review-grid::-webkit-scrollbar {
  display: none;
}

[data-type='section-review-grid-02'] .wrap-review-grid .title-review {
  margin-bottom: 40px;
}

[data-type='section-review-grid-02'] .wrap-review-grid .title-review h1,
[data-type='section-review-grid-02'] .wrap-review-grid .title-review h2,
[data-type='section-review-grid-02'] .wrap-review-grid .title-review h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-review-grid-02'] .wrap-review-grid .title-review p {
  font-size: 16px;
  margin-bottom: 16px !important;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review {
  width: 100%;
  max-width: 100%;
  position: relative;
  padding-bottom: 20px;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review {
  display: flex;
  flex-direction: column;
  height: auto;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card {
  background: #ffffff;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 15px;
  border: 3px solid rgb(212, 212, 212);
  position: relative;
  overflow: auto;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-avatar {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e0e0e0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px !important;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-avatar::before {
  content: '';
  font-size: 24px;
  color: #999;
  position: absolute;
  z-index: 1;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 2;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-name {
  font-size: 18px;
  font-weight: bold !important;
  margin: 0 0 16px 0 !important;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content {
  margin-bottom: 16px !important;
  text-align: center;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content p {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.3s ease;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .review-content.expanded p {
  -webkit-line-clamp: unset !important;
  line-clamp: unset !important;
  overflow: visible;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars svg {
  fill: #c4c4c4;
  width: 20px;
  height: 20px;
}

[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-review-grid-02'] .wrap-review-grid .wrap-arrows {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

[data-type='section-review-grid-02'] .wrap-review-grid .wrap-arrows svg {
  width: 32px;
  height: 32px;
  cursor: pointer;
}


@container (max-width: 768px) {
  [data-type='section-review-grid-02'] [data-attribute='review-grid-container'] {
    padding: 16px 0;
  }

  [data-type='section-review-grid-02'] .wrap-review-grid .title-review {
    margin-bottom: 32px;
  }

  [data-type='section-review-grid-02'] .wrap-review-grid .title-review h1,
  [data-type='section-review-grid-02'] .wrap-review-grid .title-review h2,
  [data-type='section-review-grid-02'] .wrap-review-grid .title-review h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-review-grid-02'] .wrap-review-grid .title-review p {
    font-size: 14px;
  }

  [data-type='section-review-grid-02'] .wrap-review-grid .body-review {
    padding-bottom: 24px;
  }

  [data-type='section-review-grid-02'] .wrap-review-grid .body-review .review-slider .item-review .review-card .reviewer-name {
    font-size: 16px;
  }
}
`;

export default sectionReviewGrid02Css;
